import React, { useCallback, useEffect } from "react";
import history from "libs/history";
import { Router } from "react-router-dom";
import routes from "./config/routes";
import Routes from "components/Routes";
import { useAutoSetThemeColor} from "store/reducers/theme";
import hrtpsLog from "@hrtps/log";
import storage from 'libs/storage';
import { REACT_APP_ENV } from 'config'

function App() {
  const initLog = useCallback(() => {
    hrtpsLog.init({
      env: REACT_APP_ENV,
      tenantId: "无租户id",
      serviceCode: "ssc-chatbot-pc",
      runtimeEnv: "WINDOW",
      getCustomizeContent: () => {
        return {};
      },
    });
  }, []);
  useEffect(() => {
    initLog()
  }, [])
  useAutoSetThemeColor();
  useEffect(() => {
    hrtpsLog.init({
      // env: "环境变量，根据不同环境将日志上传到不同的地址: DEV|TEST|PROD",
      env: REACT_APP_ENV,
      tenantId: storage.getCompanyID() || '--',
      serviceCode: "ssc-chatbot-pc",
      runtimeEnv: "ssc-chatbot-pc",
      getCustomizeContent: () => {
        // 非必传，
        // 该方法会在每次打点的时候执行，一般用于返回公共参数，如用户信息等，
        // 返回的参数每次打点都会携带在content.customizeContent中
        // console.log("REACT_APP_ENV:", REACT_APP_ENV)
        // return {TOKEN_KEY: storage.getToken()};
      },
    });
  }, []);
  return (
    <div id="App">
      <Router history={history}>
        <Routes routes={routes} />
      </Router>
    </div>
  );
}

export default App;
